import * as jsxRuntime from "/home/rainer/Workspaces/recogito/annotorious-openseadragon/node_modules/preact/jsx-runtime/dist/jsxRuntime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment